export function normalizeString(string?: string) {
  return string
    ? string
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
    : '';
}
